import { Component } from '@angular/core';
import { AdminActionsDirective } from '@app/main/admin/directives/admin-actions.directive';
import { FormControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AdminService } from '@app/main/admin/admin.service';
import { DialogService, ReportService, SnackService } from '@shared/services';
import { IReport } from '@shared/interfaces';
import { ModuleService } from '@shared/services/module.service';

@Component({
    selector: 'app-admin-report-create',
    templateUrl: './admin-report-create.component.html',
    styleUrls: ['./admin-report-create.component.scss'],
    standalone: false
})
export class AdminReportCreateComponent extends AdminActionsDirective {
    formGroup: UntypedFormGroup;

    constructor(
        private reportService: ReportService,
        private fb: UntypedFormBuilder,
        private snack: SnackService,
        adminService: AdminService,
        dialogService: DialogService,
        moduleService: ModuleService
    ) {
        super(adminService, dialogService, moduleService);
        this.buildForm();
    }

    async createItem(event): Promise<void> {
        this.disableSubmitter(event);

        if (this.formGroup.valid) {
            try {
                const result = await this.reportService.createItem(this.formGroup.getRawValue());
                this.snack.openSnackBarSuccess('Report item(s) created successfully.');
                this.goToReports();
            } catch (e) {
                this.snack.openSnackBarError(e.error.message);
            }
        } else {
            this.snack.openSnackBarError('Please check your input.');
        }

        this.enableSubmitter(event);
    }

    get item(): IReport {
        return this.formGroup.value;
    }

    private buildForm(): void {
        const currentYear = new Date().getFullYear();

        this.formGroup = this.fb.group({
            responsible: new FormControl({ value: [], disabled: false }, [Validators.required]),
            template: new FormControl({ value: null, disabled: false }, [Validators.required]),
            dueDate: new FormControl({ value: new Date(currentYear, 9, 31), disabled: false }, [Validators.required]),
            reportStartDate: new FormControl({ value: new Date(currentYear - 1, 9, 1), disabled: false }, [
                Validators.required
            ]),
            reportEndDate: new FormControl({ value: new Date(currentYear, 8, 30), disabled: false }, [
                Validators.required
            ])
        });
    }
}
